import { colors } from './colors';
import { typography } from './typography';
import { spacing } from './spacing';
import { reviewDesk } from './reviewDesk';

/**
 * Complete Design System Theme
 *
 * Central theme configuration for MentorCoaching.AI
 * Ensures consistency across all platforms and components
 */

export const theme = {
  colors,
  reviewDesk,
  typography,
  spacing,

  // Border radius scale
  borderRadius: {
    none: 0,
    sm: 4,
    md: 8,
    lg: 12,
    xl: 16,
    '2xl': 24,
    full: 9999,
  },

  // Shadow system
  shadows: {
    sm: {
      shadowColor: colors.shadow.light,
      shadowOffset: { width: 0, height: 1 },
      shadowOpacity: 1,
      shadowRadius: 2,
      elevation: 1,
    },
    md: {
      shadowColor: colors.shadow.medium,
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 1,
      shadowRadius: 4,
      elevation: 2,
    },
    lg: {
      shadowColor: colors.shadow.dark,
      shadowOffset: { width: 0, height: 4 },
      shadowOpacity: 1,
      shadowRadius: 8,
      elevation: 4,
    },
    xl: {
      shadowColor: colors.shadow.dark,
      shadowOffset: { width: 0, height: 8 },
      shadowOpacity: 1,
      shadowRadius: 16,
      elevation: 8,
    },
  },

  // Z-index scale
  zIndex: {
    base: 0,
    overlay: 10,
    modal: 20,
    toast: 30,
    tooltip: 40,
  },

  // Animation timing
  animation: {
    fast: 150,
    normal: 250,
    slow: 350,
  },
} as const;

export type Theme = typeof theme;

export { colors, reviewDesk, typography, spacing };
export default theme;
